import { Dialog } from 'vant';

function trimBlankLines(lines) {
  let start = 0;
  let end = lines.length;

  while (start < end && !lines[start].trim()) {
    start += 1;
  }

  while (end > start && !lines[end - 1].trim()) {
    end -= 1;
  }

  return lines.slice(start, end);
}

function escapeHtml(text) {
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function parseRecommendedWording(wording) {
  if (typeof wording !== 'string' || !wording.trim()) {
    return [];
  }

  const lines = wording.replace(/\r\n?/g, '\n').split('\n');
  const sections = [];
  let currentSection = null;
  let prefaceLines = [];

  const addSection = (section) => {
    const content = trimBlankLines(section.contentLines).join('\n');

    if (content.trim()) {
      sections.push({
        title: section.title,
        content,
      });
    }
  };

  lines.forEach((line) => {
    const headingMatch = line.match(/^##\s+(.+?)\s*$/);

    if (headingMatch) {
      if (currentSection) {
        addSection(currentSection);
      } else if (prefaceLines.some(item => item.trim())) {
        addSection({
          title: '默认话术',
          contentLines: prefaceLines,
        });
      }

      currentSection = {
        title: headingMatch[1],
        contentLines: [],
      };
      prefaceLines = [];
      return;
    }

    if (currentSection) {
      currentSection.contentLines.push(line);
    } else {
      prefaceLines.push(line);
    }
  });

  if (currentSection) {
    addSection(currentSection);
  }

  if (sections.length) {
    return sections;
  }

  return [{
    title: '建议话术',
    content: trimBlankLines(lines).join('\n'),
  }];
}

function buildSelectionMessage(sections, groupName) {
  const options = sections.map((section, index) => {
    const checked = index === 0 ? ' checked' : '';
    const preview = escapeHtml(section.content);
    const title = escapeHtml(section.title || `话术 ${index + 1}`);

    return `
      <label class="wording-option">
        <input type="radio" name="${groupName}" value="${index}"${checked} />
        <span class="wording-option-frame">
          <span class="wording-option-indicator"></span>
          <span class="wording-option-body">
            <span class="wording-option-title">${title}</span>
            <span class="wording-option-preview">${preview}</span>
          </span>
        </span>
      </label>
    `;
  }).join('');

  return `<div class="wording-selector">${options}</div>`;
}

export async function selectRecommendedWording(wording, options = {}) {
  const sections = parseRecommendedWording(wording);

  if (!sections.length) {
    return null;
  }

  if (sections.length === 1) {
    try {
      const action = await Dialog.confirm({
        title: options.title || '建议话术',
        message: sections[0].content,
        messageAlign: 'left',
        confirmButtonText: options.confirmButtonText || '复制话术',
        cancelButtonText: options.cancelButtonText || '跳过',
        showCancelButton: true,
        className: 'recommended-wording-dialog',
        allowHtml: false,
      });

      return action === 'confirm' ? sections[0].content : null;
    } catch (err) {
      return null;
    }
  }

  const groupName = `recommended-wording-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  let selectedIndex = 0;

  try {
    const action = await Dialog.confirm({
      title: options.title || '建议话术',
      message: buildSelectionMessage(sections, groupName),
      messageAlign: 'left',
      confirmButtonText: options.confirmButtonText || '复制话术',
      cancelButtonText: options.cancelButtonText || '跳过',
      showCancelButton: true,
      className: 'recommended-wording-dialog recommended-wording-selection-dialog',
      allowHtml: true,
      beforeClose(actionName, done) {
        if (actionName === 'confirm') {
          const checkedInput = document.querySelector(`input[name="${groupName}"]:checked`);
          selectedIndex = checkedInput ? Number(checkedInput.value) : 0;
        }

        done();
      },
    });

    return action === 'confirm' && sections[selectedIndex]
      ? sections[selectedIndex].content
      : null;
  } catch (err) {
    return null;
  }
}
